import { router, usePage } from "@inertiajs/react"
import { useEffect, useState } from "react"
import { toast } from "sonner"

import type { Flash } from "@/types"

const emptyFlash = {}

export const useFlash = () => {
  const { flash } = usePage<{ flash: Flash }>().props
  const [currentFlash, setCurrentFlash] = useState<Flash>(emptyFlash)

  useEffect(() => {
    setCurrentFlash(flash)
  }, [flash])

  router.on("start", () => {
    setCurrentFlash(emptyFlash)
  })

  useEffect(() => {
    // Stable ids dedupe when the hook is mounted in more than one layout
    // (e.g. the portal renders both PersistentLayout and FullscreenLayout).
    if (currentFlash.alert) {
      toast.error(currentFlash.alert, { id: `flash-alert:${currentFlash.alert}` })
    }
    if (currentFlash.notice) {
      const link = currentFlash.link
      toast.success(currentFlash.notice, {
        id: `flash-notice:${currentFlash.notice}`,
        // A toast that says a brief was added can open it (INCO-470). The
        // record may live on another host, so a full navigation, not a visit.
        action: link ? { label: link.label, onClick: () => window.location.assign(link.href) } : undefined,
      })
    }
  }, [currentFlash])
}
